"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.purpleTheme = void 0;
var default_1 = __importDefault(require("./default"));
// tslint:disable:object-literal-sort-keys
exports.purpleTheme = __assign(__assign({}, default_1.default), { name: 'purple', colors: __assign(__assign({}, default_1.default.colors), { main: {
            base: '#990099',
            tap: '#771483',
            hover: '#925499',
            focus: 'rgba(153,0,153,0.40)'
        }, accent: {
            base: '#990099'
        } }) });
// tslint:enable:object-literal-sort-keys
exports.default = exports.purpleTheme;
